import { render, staticRenderFns } from "./AddAnotherVehicle.vue?vue&type=template&id=5d61dd2f&"
import script from "./AddAnotherVehicle.vue?vue&type=script&lang=js&"
export * from "./AddAnotherVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports